<ion-header>
	<ion-toolbar>

		<ion-buttons slot="start" *ngIf="canSelectAll">
			<ion-button (click)="doSelectAll()">
				<ion-icon slot="icon-only" name="checkmark-done-outline"></ion-icon>
				{{label}}
			</ion-button>
		</ion-buttons>

		<ion-title *ngIf="title">{{title}}</ion-title>

		<ion-buttons slot="end">
			<ion-button (click)="doAbort()">
				<ion-icon slot="icon-only" name="close"></ion-icon>
			</ion-button>
		</ion-buttons>

	</ion-toolbar>

	<ion-toolbar>
		<ion-searchbar placeholder="Ricerca..." debounce="250" (ionClear)="doReset()" (ionChange)="doChange($event)"></ion-searchbar>
	</ion-toolbar>


</ion-header>

<ion-content>

	<ion-list>
		<ion-radio-group>
			<ion-item *ngFor="let item of filteredItems">
				<ion-label>{{item.name}}</ion-label>
				<ion-checkbox #MyCheckbox [checked]="doChecked(item.id)" (click)="clicked(item.id)" [value]="item.id">{{item.name}}</ion-checkbox>
			</ion-item>
		</ion-radio-group>
	</ion-list>

</ion-content>

<ion-footer>
	<ion-grid>
		<ion-row>
			<ion-col>
				<ion-button expand="block" color="medium" fill="outline" (click)="doAbort()">Annulla</ion-button>
			</ion-col>
			<ion-col>
				<ion-button expand="block" color="success" (click)="doApply()">Applica</ion-button>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-footer>
